<template>
  <div ref="videoPlayer">
    <div slot="loading" class="loading-container vjs-waiting" v-if="!playerReady">
      <div class="vjs-loading-spinner" dir="ltr">
      </div>
    </div>
    <div slot="body" class="videojs-player" v-show="playerReady">
      <video
        :id="playerElement"
        class="video-js vjs-big-play-centered"
        @seeked="seekedEvent"
        @timeupdate="timeUpdateEvent"
        @playing="playingEvent"
        @pause="pauseEvent"
        @ended="endedEvent"
      >
        <source v-if="record.url" :src="record.url" :type="record.mimetype"/>
      </video>
    </div>
  </div>
</template>

<script>
// Record player component
// Reponsible for intitializing a videojs instance, loading and playing videos.
// This component was quickly copy-pasted from the ModalRecordPlayer.vue
// I didn't have time to refactor it :(
// FIXME: fix code repetition between this and the ModalRecordPlayer component

import videojs from 'video.js'
require('video.js/dist/video-js.css')
// import Thumbnails from '../../../libs/videojs-thumbnails/videojs.thumbnails.js'
// require('../../../libs/videojs-thumbnails/videojs.thumbnails.css')
// videojs.registerPlugin('thumbnails', Thumbnails)

// import events from '../../../services/events'

import debounce from 'lodash.debounce'

export default {
  name: 'RecordPlayer',
  props: ['options', 'sizeStyles'],
  data () {
    return {
      playerReady: false,
      record: {
        url: null
      },
      playerElement: `videojs-${this._uid}`,
      playerOptions: {
        'controls': true,
        'autoplay': false,
        'preload': false
      }
    }
  },
  watch: {
    'options': function (newValue, oldValue) {
      if (newValue && oldValue && newValue.url !== oldValue.url) {
        this.player.pause()
        this.play(newValue)
      }
    }
  },
  mounted: function () {
    this.resizeHandler = debounce(this.adjustRatioEvent, 300)
    window.addEventListener('resize', this.resizeHandler)
    this.setupPlayer().then(() => {
      this.play(this.options)
    })
  },
  methods: {
    play (record) {
      this.record = record
      if (this.record.height && this.record.width) {
        this.adjustRatio(this.record.width / this.record.height)
      }
      this.playerReady = false
      this.$nextTick(function () {
        this.player.on('loadedmetadata', () => {
          this.adjustRatio()
          this.playerReady = true
        })
        this.player.pause()
        this.player.loadingSpinner.show()
        this.player.src(record.url)
        this.player.poster(record.thumbnail)
        if (record.sprite) {
          this.setUpThumbnailPreviews(this.player, record.sprite)
        } else {
          this.clearThumbnailPreviews()
        }
        this.player.load()
        this.player.play()
      })
    },
    setupPlayer: function () {
      if (this.playerSetUp) {
        return
      }
      const _this = this
      return new Promise((resolve, reject) => {
        videojs(this.playerElement, this.playerOptions, function () {
          _this.player = this
          _this.playerSetUp = true
          _this.player.thumbnails()
          resolve()
        })
      })
    },
    clearThumbnailPreviews () {
      this.player.thumbnails().updateState({})
    },
    // generate the required css for the thumbnail previews
    // when hovering in the video control bar
    setUpThumbnailPreviews (player, sprite) {
      let frames = Math.floor(sprite.width / sprite.h_interval)
      let options = {
        0: {
          src: sprite.url,
          style: {
            height: sprite.height + 'px',
            width: sprite.width + 'px',
            clip: `rect(0, ${sprite.h_interval}px, ${sprite.height}px, 0)`,  // (top, right, bottom, left)
            left: `-${sprite.h_interval / 2}px`
          }
        }
      }
      for (var i = 1; i < frames; i++) {
        options[i] = {
          style: {
            clip: `rect(0, ${sprite.h_interval * (i + 1)}px, ${sprite.height}px, ${sprite.h_interval * i}px)`,
            left: `-${(sprite.h_interval / 2) + sprite.h_interval * i}px`
          }
        }
      }
      player.thumbnails().updateState(options)
    },
    adjustRatioEvent (event) {
      this.adjustRatio()
    },
    // manually adjust the video size to make it fit in the screen,
    // taking into account the aspect ratio.
    // (there might be ways to achieve this with pure CSS)
    adjustRatio (ratio) {
      // accept an optional ratio argument, otherwise use the video's ratio
      if (this.playerSetUp) {
        if (!ratio) {
          ratio = this.player.videoWidth() / this.player.videoHeight()
        }
        var el = document.getElementById(this.playerElement)
        if (ratio && el) {
          // set width to 80% of window size
          if (this.sizeStyles) {
            el.style.width = this.sizeStyles.width
            el.style.height = this.sizeStyles.height
          } else {
            let width = 640
            let height = Math.floor(640 / ratio)
            if (width < height) {
              height = 640
              width = Math.floor(640 * ratio)
            }
            el.style.width = width + 'px'
            el.style.height = height + 'px'
            if (this.$root.$children[0].$data.clientId === 'digiteka') {
              let width = Math.floor(this.$parent.$parent.$parent.$refs.testRef.scrollWidth)
              console.log(window.innerWidth, this.$parent.$parent.$parent.$refs.testRef.scrollWidth, '--------------')
              let height = Math.floor(width / ratio)
              if (width < height) {
                height = window.innerHeight * 0.8
                width = Math.floor(height * ratio)
              }
              el.style.width = width + 'px'
              el.style.height = height + 'px'
            }
          }
        }
      }
    },
    seekedEvent (event) {
      this.$emit('seeked', event)
    },
    timeUpdateEvent (event) {
      this.$emit('timeupdate', event)
    },
    playingEvent (event) {
      this.$emit('playing')
    },
    pauseEvent (event) {
      this.$emit('pause')
    },
    endedEvent (event) {
      this.$emit('ended')
    }
  }, // methods
  beforeDestroy () {
    this.player.pause()
    this.player.dispose()
    window.removeEventListener('resize', this.resizeHandler)
  }
}
</script>



// WEBPACK FOOTER //
// RecordPlayer.vue?78aaad1e